import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/permission'
import CompositionApi from '@vue/composition-api'
import 'element-ui/lib/theme-chalk/index.css';
import 'uno.css'
import element from './plugins/elementui_'
require('@/directive/btnPermission')
require('@/directive/drag')
Vue.use(element)
Vue.use(CompositionApi)
import '@/plugins/apexcharts'
import './qiankun.js'
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
